import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectionType } from '../../models/selection-type.enum';
import { searchLoadingState } from '@usf/ngrx-product';

@Component({
  selector: 'app-mobile-search-operations',
  templateUrl: './mobile-search-operations.component.html',
  styleUrls: ['./mobile-search-operations.component.scss'],
})
export class MobileSearchOperationsComponent {
  @Input() selection: SelectionType;
  @Input() isGuestUser: boolean;
  @Input() showInventory: boolean;
  @Input() isAddToList: boolean;
  @Input() isInventory: boolean;
  @Input() showAddIngredient: boolean;
  @Input() isThreeOperationButtons: boolean;

  @Output() selectionChange = new EventEmitter<SelectionType>();

  readonly SelectionType = SelectionType;

  constructor() {}

  handleSelectionTypeChange(selectionType: SelectionType): void {
    this.selectionChange.emit(selectionType);
  }

  get SearchLoadingState(): typeof searchLoadingState {
    return searchLoadingState;
  }
}
